import { render } from "./CustomCheckbox.vue?vue&type=template&id=4ed6cdfe&scoped=true"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js"

import "./CustomCheckbox.vue?vue&type=style&index=0&id=4ed6cdfe&scoped=true&lang=css"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed6cdfe"]])

export default __exports__